
export const mutations = {
  SET_SKU (state: any, data: any) {
    state.sku = data
  },
}
